import { Controller } from '@hotwired/stimulus';

export default class DescriptionTestController extends Controller {
  static values = {
    tabIndex: Number
  };

  static targets = [
    'answerField'
  ];

  onInput() {
    const value = this.answerFieldTarget.value;

    if (value) {
      this.dispatch('completeAnswer', {
        detail: {
          answer:   value,
          tabIndex: this.tabIndexValue
        }
      });
    } else {
      this.dispatch('clearAnswer', {
        detail: {
          tabIndex: this.tabIndexValue
        }
      });
    }
  }

  disableControls() {
    this.answerFieldTarget.disabled = true;
  }
}
